import 'dayjs/locale/hu'
import 'dayjs/locale/en'

import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat' // ES 2015
import localeData from 'dayjs/plugin/localeData'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import weekday from 'dayjs/plugin/weekday'
import i18next, { t } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initLitI18n, translate } from 'lit-i18n'

import en from './locales/en.json'
import hu from './locales/hu.json'

dayjs.extend(localeData)
dayjs.extend(weekday)
dayjs.extend(LocalizedFormat)
dayjs.extend(customParseFormat)

const DEFAULT_LOCALE = 'hu'

const getDefaultLang = () => {
  let lang =
    document.documentElement.lang || navigator.language || DEFAULT_LOCALE
  lang = lang.slice(0, 2)
  return lang
}

i18next
  .use(LanguageDetector)
  .use(initLitI18n)
  .init({
    fallbackLng: 'hu',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          ...en,
        },
      },
      hu: {
        translation: {
          ...hu,
        },
      },
    },
  })

dayjs.locale(getDefaultLang())
i18next.changeLanguage(getDefaultLang())

const documentElementObserver = new MutationObserver(update)
documentElementObserver.observe(document.documentElement, {
  attributes: true,
  attributeFilter: ['dir', 'lang'],
})

export function update() {
  const lang = getDefaultLang()

  dayjs.locale(lang)
  i18next.changeLanguage(lang)
}

export { i18next, t, translate }
